var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPauseLtr = function SvgPauseLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10a2 2 0 0 0-2 2v76a2 2 0 0 0 2 2h23a2 2 0 0 0 2-2V12a2 2 0 0 0-2-2zm40 0a2 2 0 0 0-2 2v76a2 2 0 0 0 2 2h23a2 2 0 0 0 2-2V12a2 2 0 0 0-2-2z"
  })));
};
export default SvgPauseLtr;